<ui-input fluid icon="search" label="ctrl+k" placeholder="Search..." class="inline-search" exportparts="input:search-input, icon:search-icon, label:search-label"></ui-input>
<ui-modal glass>
  <div class="search">
    <ui-input debounced fluid search dark autofocus></ui-input>
  </div>
  <div class="results">
    {#if hasAny displayResults}
      {#each displayResults}
        <a class="result {activeIf is index selectedIndex}" href="{url}">
          <h3>
            {title}
            {#if subtitle}
              <span class="subtitle"><span>in</span> {subtitle}</span>
            {/if}
            <div class="tags">
              {#if hasAny tags}
                {#each tags}
                  <span class="{color} tag">{text}</span>
                {/each}
              {/if}
            </div>
          </h3>
          <div class="description">{description}</div>
        </a>
      {/each}
    {else if noResults}
      <div class="placeholder">
        <ui-icon icon="x circle"></ui-icon>
        <p>There are no results for "<b>{searchTerm}</b>".</p>
      </div>
    {else}
      <div class="placeholder">
        <ui-icon icon="search"></ui-icon>
        <p>Enter a search term above to see results...</p>
      </div>
    {/if}
  </div>
</ui-modal>
